/* eslint-disable */

var ua = window.navigator.userAgent;
// 是否是测试版
var isDebug = /:[\d]+$/.test(window.location.host);



// 是否是108社区app
var isApp = /108sq/i.test(ua);
var isAndroid = /android/i.test(ua);
var isIPhone = /iphone/i.test(ua);

/**
 * jsonp请求方法（简易）
 * @param {Object} options - 请求参数配置
 *   @param {String} options.url - 请求地址
 *   @param {Object} options.params - 请求参数
 *   @param {Function} options.success - 成功回调函数
 *   @param {String} options.callback - 成功回调函数的名字
 */
function jsonpRequest(options) {
    var script = document.createElement('script');
    if (options.callback) {
      window[options.callback] = options.success || function () {};
    } else {
      var random = parseInt(Math.random() * 1000000) + 1000000;
      options.callback = '_jsonpCallback' + random;
      window[options.callback] = options.success || function () {};
    }
    script.onload = function () {
      this.parentNode.removeChild(this);
    };
    script.onerror = function () {
      this.parentNode.removeChild(this);
    };
    var head = document.querySelector('head');
    head.appendChild(script);
    script.src = options.url + '?callback=' + options.callback + '&' + j2p(options.params);
  }

  // json格式文件转换为字符串
function j2p(json) {
    var arr = [];
    for (var i in json) {
      json.hasOwnProperty(i) && arr.push(i + '=' + json[i]);
    }
    return arr.join('&');
  }

  function getOS() {
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      // 安卓手机
      return 'Android';
    } else if (u.indexOf('iPhone') > -1) {
      // 苹果手机
      return 'iPhone OS';
    } else if (u.indexOf('Windows Phone') > -1) {
      return 'Windows Mobile';
    }
    return '';
  }


  var appInfo;
var ua$1 = window.navigator.userAgent;
if (isApp) {
  var reg = /108sq\/([^/]*)\/([^/]*)\/([^/]*)\/([^/]*)$/i;
  var match = ua$1.match(reg);
  appInfo = {
    name: '108sq',
    version: match ? match[1] : '',
    cityId: match ? match[2] : '',
    channelName: match ? match[3] : '',
    netType: match ? match[4] : ''
  };
} else {
  appInfo = null;
}

var appInfo$1 = appInfo;


/**
* hosts - 域名
* @return {Object}
*/

var hosts = isDebug ? {
    main: 'http://www.108sq.org:920',
    app: 'http://app.108sq.org:920',
    login: 'http://login.108sq.org:807',
    userop: 'http://userop.108sq.org:1204',
    discuss: 'http://discuss.108sq.org:901',
    discuss1: 'http://discuss1.108sq.org:1202',
    uploadimg: 'http://photo.108sq.org:811',
    showimg: 'http://photoshow.108sq.org:814',
    merchant: 'http://sj.108sq.org:703',
    activity: 'http://huodong.108sq.org:815',
    shuo: 'http://shuo.108sq.org:821',
    shuocdn: 'http://shuo.108sq.org:821',
    dynamic: 'http://dynamic.108sq.org:826',
    mtalk: 'http://mtalksvc.108sq.org:831',
    shop: 'http://shop.108sq.org:1505',
    dynamicnew: 'http://dynamic.108sq.org:826',
    jiangli: 'http://jiangli.tc108.org:1505',
    love: 'http://love.108sq.org:1505',
    pay: 'http://pay.108sq.org:1203',
    friendv2: 'http://friendv2.108sq.org:1505',
    friend: 'http://friend.108sq.org:806',
    pkplugin: 'http://pkplugin.108sq.org:1505',
    business: 'http://business.108sq.org:920',
    message: 'http://message.108sq.org:809',
    businessad: 'http://businessad.108sq.org:71',
    enrolling: 'http://enrolling.108sq.org:1505',
    m: 'http://m.108sq.org:920',
    nodomain: 'http://108sq.org:920',
    mtalksvcv2: 'http://mtalksvcv2.108sq.org:831',
    mtalksvc: 'http://mtalksvc.108sq.org:831',
    common: 'http://common.108sq.org:1505',
    // common: '/api',
  usertxcdn: 'http://usertxcdn.108sq.org:920',
    vote: 'http://vote.108sq.org:1505',
    images: 'http://images.108sq.org:920'
  } : {
    main: 'http://www.108sq.cn',
    app: 'http://app.108sq.cn',
    login: 'http://login.108sq.cn',
    userop: 'http://userop.108sq.cn',
    discuss: 'http://discuss.108sq.cn',
    discuss1: 'http://discuss.108sq.cn',
    uploadimg: 'http://photo.108sq.cn',
    showimg: 'http://photoshow.108sq.cn',
    merchant: 'http://sj.108sq.cn',
    activity: 'http://huodong.108sq.cn',
    shuo: 'http://shuo.108sq.cn',
    shuocdn: 'http://shuocdn.108sq.cn',
    dynamic: 'http://dynamic.108sq.cn',
    mtalk: 'http://mtalksvc.tc108.net',
    shop: 'http://shop.108sq.cn',
    dynamicnew: 'http://dynamic.108sq.cn',
    jiangli: 'http://jiangli.108sq.cn',
    love: 'http://love.108sq.cn',
    pay: 'http://pay.108sq.cn',
    friendv2: 'http://friendv2.108sq.cn',
    friend: 'http://friend.108sq.cn',
    pkplugin: 'http://pkplugin.108sq.cn',
    business: 'http://business.108sq.cn',
    message: 'http://message.108sq.cn',
    businessad: 'http://businessad.108sq.cn',
    enrolling: 'http://enrolling.108sq.cn',
    m: 'http://m.108sq.cn',
    nodomain: 'http://108sq.cn',
    mtalksvcv2: 'http://mtalksvcv2.sq108.net',
    mtalksvc: 'http://mtalksvc.sq108.net',
    common: 'http://common.108sq.cn',
    usertxcdn: 'http://usertxcdn.108sq.cn',
    vote: 'http://vote.108sq.cn',
    images: 'http://images.108sq.cn'
  };


  /**
 * app ajax方法，无跨域问题，仅在社区中有用，自带登陆信息
 * @param {Object} configs - 参数配置
 *   @param {String} configs.type - 请求类型，默认"GET"
 *   @param {String} configs.url - 请求地址，必须是完整的url地址
 *   @param {String} config.waiting - 请求开始到结束为止等待过程中，请求等待过程中显示的信息
 *   @param {Object} cofigs.params - 请求参数
 *   @param {Function} configs.success - 请求成功的回掉函数
 *   @param {Function} configs.error - 请求错误的回掉函数
 *   @param {Function} configs.complete - 请求完成的回掉函数
 *   @param {Boolean} configs.isNeedDecode - 请求的参数是否需要URI解码
 */
var ajax = function ajax(configs) {
    var defaults = {
      type: 'GET',
      url: '',
      waiting: '',
      params: {},
      success: null,
      error: null,
      complete: null,
      isNeedDecode: false
    };
    var options = {};
    for (var i in defaults) {
      options[i] = configs.hasOwnProperty(i) ? configs[i] : defaults[i];
    }
    var j2p = function j2p(json) {
      var a = [];
      for (var i in json) {
        a.push(i + '=' + json[i]);
      }return a.join('&');
    };
    var random = parseInt(Math.random() * 1000000000000 + 1000000000000);
    var success = '';
    var error = '';
    var complete = '';
    if (options.success) {
      success = 'APP_CALLBACK_SUCCESS_' + random;
      window[success] = function (response) {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
        options.success && options.success.call(window, response);
      };
    }
    if (options.error) {
      error = 'APP_CALLBACK_ERROR_' + random;
      window[error] = function () {
        options.error && options.error.call(window);
      };
    }
    if (options.complete) {
      complete = 'APP_CALLBACK_COMPLETE_' + random;
      window[complete] = function () {
        options.complete && options.complete(window);
      };
    }

    var params = {
      type: options.type.toUpperCase(),
      url: options.url,
      waiting: options.waiting,
      params: j2p(options.params),
      success: success,
      error: error,
      complete: complete,
      isNeedDecode: options.isNeedDecode
    };
    // 判断是否是本地文件
    this._callMethod('ajax', JSON.stringify(params));
  };



var ajax$1 = ajax;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();


  /**
 * 上传图片
 * @param {object} configs - 配置信息
 *   @param {String} configs.url - 接口地址，必须是完整的url
 *   @param {String} configs.waiting - 请求过程中显示的等待信息
 *   @param {Number} configs.maxwidth - 图片最大边长
 *   @param {Number} configs.quality - 图片质量 0 - 100
 *   @param {String} configs.dataType -'json' or 'text' 传到回调函数中的数据类型
 *   @param {Object} configs.params - 请求的参数
 *   @param {Function} configs.start - 开始上传时回调函数
 *   @param {Function} configs.cancel - 请求取消时回掉函数
 *   @param {Function} configs.success - 图片上传成功时回调函数
 *   @param {Function} config.failure - 图片上传失败时回调函数
 *   @param {Function} configs.complete - 请求完成时回调函数
 */

var openUpload = function openUpload(configs) {
    var defaults$$1 = {
      url: '',
      waiting: '',
      // 最大边长
      maxwidth: 0,

      // 图片质量 0-100
      quality: 100,

      dataType: 'json',
      params: {},
      start: null,
      cancel: null,
      success: null,
      failure: null,
      complete: null
    };
    var options = {};
    for (var i in defaults$$1) {
      options[i] = configs.hasOwnProperty(i) ? configs[i] : defaults$$1[i];
    }
    var j2p = function j2p(json) {
      var a = [];
      for (var i in json) {
        a.push(i + '=' + json[i]);
      }return a.join('&');
    };
    var random = parseInt(Math.random() * 1000000000000 + 1000000000000);
    var start = '';
    var cancel = '';
    var success = '';
    var failure = '';
    var complete = '';
    if (options.start) {
      start = 'APP_UPLOAD_CALLBACK_START_' + random;
      window[start] = function () {
        options.start && options.start(window);
      };
    }
    if (options.cancel) {
      cancel = 'APP_UPLOAD_CALLBACK_CANCEL_' + random;
      window[cancel] = function () {
        options.cancel && options.cancel(window);
      };
    }
    if (options.complete) {
      complete = 'APP_UPLOAD_CALLBACK_COMPLETE_' + random;
      window[complete] = function () {
        options.complete && options.complete(window);
      };
    }
    if (options.success) {
      success = 'APP_UPLOAD_CALLBACK_SUCCESS_' + random;
      window[success] = function (response) {
        if (options.dataType === 'json' && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== 'object') {
          response = JSON.parse(response);
        } else if (options.dataType === 'text') {
          if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
            response = JSON.stringify(response);
          }
        }
        options.success && options.success.call(window, response);
      };
    }
    if (options.failure) {
      failure = 'APP_UPLOAD_CALLBACK_FAILURE_' + random;
      window[failure] = function (response) {
        if (options.dataType === 'json' && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== 'object') {
          response = JSON.parse(response);
        } else if (options.dataType === 'text') {
          if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
            response = JSON.stringify(response);
          }
        }
        options.failure && options.failure.call(window, response);
      };
    }
    if (options.complete) {
      complete = 'APP_CALLBACK_COMPLETE_' + random;
      window[complete] = function () {
        options.complete && options.complete(window);
      };
    }


    var params = {
        url: options.url,
        waiting: options.waiting,
        params: j2p(options.params),
        maxwidth: options.maxwidth,
        quality: options.quality,
        start: start,
        cancel: cancel,
        success: success,
        failure: failure,
        complete: complete
      };
      this._callMethod('openUpload', JSON.stringify(params));
    };


    /**
 * 统计方法(非客户端环境下利用jsonp发送请求)
 * @param {Object} configs - 统计的信息
 *   @param {String} configs.pageName - 页面名，必填
 *   @param {String} configs.eventName - 事件名，必填
 */

var statistics = void 0;
if (isApp) {
  statistics = function statistics(configs) {
    // 兼容已经经过字符串化处理的字符串
    if (typeof configs === 'string') {
      return this._callMethod('webStatistics', configs);
    }
    return this._callMethod('webStatistics', JSON.stringify(configs));
  };
} else {
  var ma = {
    log: function log(params) {
      var args = filterArgs(params);
      jsonpRequest({
        url: 'http://analytics.108sq.cn/log/',
        params: {
          version: ma.version,
          os: getOS(),
          page: params.pageName,
          event: params.eventName,
          args: encodeURIComponent(args)
        },
        callback: 'logCallback'
      });
    },
    version: '1.0.0'
  };
  statistics = ma.log;
}


function filterArgs(params) {
    var argsObj = {};
    for (var i in params) {
      if (i !== 'pageName' && i !== 'eventName' && params.hasOwnProperty(i)) {
        argsObj[i] = params[i];
      }
    }
    var args = Object.keys(argsObj).map(function (item) {
      return item + '=' + argsObj[item];
    }).join(',');
    return args;
  }

  var statistics$1 = statistics;

var app = {
  /**
   * 检查JSBrdge中是否有某具名方法
   * @private
   * @param {String} name - 方法名
   * @returns {Boolean}
   */
  _hasMethod: function _hasMethod(name) {
    return !!window['ChangShuoJSBridge'] && !!window['ChangShuoJSBridge'][name];
  },

  /**
   * 通过JSBridge调用方法
   * @private
   * @param {String} name - 需要调用的方法名
   */
  _callMethod: function _callMethod(name) {
    if (!this._hasMethod(name)) {
      return;
    }
    return window['ChangShuoJSBridge'][name].apply(window['ChangShuoJSBridge'], Array.prototype.slice.call(arguments).slice(1));
  },

  /**
   * 展示loading
   * @param {String} sTips - 内容
   */
  showWaiting: function showWaiting(sTips) {
    return this._callMethod('showWaiting', sTips);
  },

  /**
   * 隐藏loading
   */
  hideWaiting: function hideWaiting() {
    return this._callMethod('hideWaiting');
  },

  /**
   * 展示toast
   * @param {String} message - toast内容
   */
  showToast: function showToast(message) {
    return this._callMethod('showToast', message);
  },

  /**
   * 跳转登陆页面
   * @param {Boolean} isReloadOnSuccess - 登陆成功后是否刷新页面
   */
  toLogin: function toLogin(isReloadOnSuccess) {
    return this._callMethod('toLogin', isReloadOnSuccess);
  },

  /**
   * 获取用户token信息
   * @returns {String}
   */
  getToken: function getToken() {
    return this._callMethod('getToken');
  },

  /**
   * 获取设备信息
   * @returns {String}
   */
  getEncryptMobile: function getEncryptMobile() {
    return this._callMethod('getEncryptMobile');
  },

  /**
   * 获取设备信息(带时间戳)
   */
  getEncodeMobileFlag: function getEncodeMobileFlag() {
    return this._callMethod('getEncodeMobileFlag');
  },

  /**
   * 隐藏右上角按钮信息（复制链接，在浏览器中打开链接）
   */
  hideMoreMenu: function hideMoreMenu() {
    return this._callMethod('hideMoreMenu');
  },

  /**
   * 获取用户Id
   * @returns {String|Number}
   */
  getUserId: function getUserId() {
    return this._callMethod('getUserId');
  },

  /**
   * 获取用户名
   * @returns {String}
   */
  getUserName: function getUserName() {
    return this._callMethod('getUserName');
  },

  /**
   * 发送私信
   * @param {String} cnt -私信内容
   */
  sendMessage: function sendMessage(cnt) {
    return this._callMethod('sendMessage', cnt);
  },

  /**
   * 分享给微信好友
   * @param {String} title - 分享页面的标题，必填
   * @param {String} titleUrl -分享页面的链接
   * @param {String} content - 分享内容
   * @param {String} imageUrl - 分享图标的链接
   */
  shareWebPageToWeiXin: function shareWebPageToWeiXin(title, titleUrl, content, imageUrl) {
    return this._callMethod('shareWebPageToWeiXin', title, titleUrl, content, imageUrl);
  },

  /**
   * 分享到微信朋友圈
   * @param {String} title - 分享页面的标题，必填
   * @param {String} titleUrl - 分享页面的链接
   * @param {String} imageUrl - 分享图标的链接
   */
  shareWebPageToWeiXinFriends: function shareWebPageToWeiXinFriends(title, titleUrl, imageUrl) {
    return this._callMethod('shareWebPageToWeiXinFriends', title, titleUrl, '', imageUrl);
  },

  /**
   * 分享到微信、微信朋友圈、QQ、QQ空间
   * @param {Object} config - 分享信息配置
   *   @param {String} config.title - 分享页面的标题，必填
   *   @param {String} config.titleUrl - 分享页面的链接，必填
   *   @param {String} config.content - 分享页面的内容
   *   @param {String} config.imageUrl - 分享图标的链接
   *   @param {Number} config.shareType - 分享类型
   *     @example config.shareType = 1 // QQ好友
   *     @example config.shareType = 2 // QQ空间
   *     @example config.shareType = 3 // 微信好友
   *     @example config.shareType = 4 // 微信朋友圈
   *   @param {Number} infoid - 帖子的id，（分享获得积分用），非必填
   */
  shareWebPage: function shareWebPage(config) {
    return this._callMethod('shareWebPage', JSON.stringify(config));
  },

  /**
   * 打开一个新的webView（非每个页面拥有此方法）
   * 3.19.0增加 openWebWindow方法，参数与功能于此方法类似，做一个兼容
   * @param {String} url - 打开页面的url
   * @param {String} param - 记录到app本地的一个参数 客户端版本3.16.0之后添加此参数
   * @description 如没有此方法，通过location.href跳转页面
   */
  startNewWebView: function startNewWebView(url, param) {
    if (this._hasMethod('openWebWindow')) {
      return this._callMethod('openWebWindow', url, param);
    } else if (this._hasMethod('startNewWebView')) {
      return this._callMethod('startNewWebView', url, param);
    } else {
      window.location.href = url;
    }
  },

  /**
   * 客户端3.19.0新增此方法
   * 打开新的webview 此方法与startNewWebView的新实现，具体参考 startNewWebView
   */
  openWebWindow: function openWebWindow(url, param) {
    return this._callMethod('openWebWindow', url, param);
  },

  /**
   * 打开一个新的webView，本地记录一串数据
   * 客户端版本3.16.0添加此方法
   * @param {String} url - 打开页面的url
   * @param {String} param - 记录到app本地的一个参数
   */
  startNewSingleWebView: function startNewSingleWebView(url, param) {
    return this._callMethod('startNewSingleWebView', url, param);
  },

  /**
   * 获取当前记录的webViewParam
   * 3.19.0 新增getWebWindowParams方法，配合openWebWindow使用
   * 需要跟startNewSingleWebView或startNewWebView配合使用
   * 客户端版本3.16.0添加此方法
   * @returns {String}
   */
  getCurrentWebViewParam: function getCurrentWebViewParam() {
    if (this._hasMethod('getWebWindowParams')) {
      return this._callMethod('getWebWindowParams');
    }
    return this._callMethod('getCurrentWebViewParam');
  },

  /**
   * 客户端3.19.0新增此方法
   * 具体参考getCurrentWebViewParam
   */
  getWebWindowParams: function getWebWindowParams() {
    return this._callMethod('getWebWindowParams');
  },

  /**
   * 关闭单个或多个webview页面
   * 客户端3.19.0新增此方法
   * @param {String} config.name - 关闭页面的名称，主要用于android关闭时用，关闭同名页面。字段为空，则关闭当前页面
   * @param {String} config.count - 关闭页面的数量，主要用于ios关闭时用，后进先出原则。字段为空，则关闭当前页面
   */
  closeWebWindow: function closeWebWindow(config) {
    return this._callMethod('closeWebWindow', JSON.stringify(config));
  },

  /**
   * 设置当前页面(webView)名称
   * 客户端3.19.0新增此方法，配合closeWebWindow使用
   * @param {String} name - 页面的名称，主要用于android关闭时用，关闭同名页面
   */
  setWebWindowName: function setWebWindowName(name) {
    return this._callMethod('setWebWindowName', name);
  },

  /**
   * 统计方法
   */
  webStatistics: statistics$1,

  /**
   * app提供的支付方法
   * @param {Result} payInfo - 订单信息，接口返回
   * @param {Number} payType - 支付类型
   *   @example payType = 1 // 支付宝
   *   @example payType = 2 // 微信支付
   */
  pay: function pay(payInfo, payType) {
    return this._callMethod('pay', payInfo, payType);
  },

  /**
   * 获取当前站点的domain名称
   * @returns {String}
   */
  getSiteDomain: function getSiteDomain() {
    return this._callMethod('getSiteDomain');
  },

  /**
   * ajax方法
   */
  ajax: ajax$1,

  /**
   * 上传图片的方法
   */
  openUpload: openUpload,

  /**
   * 查看图片大图
   * @param {String} src -需要查看大图普片的地址
   */
  openImage: function openImage(src) {
    return this._callMethod('openImage', src);
  },

  /**
   * 右上角按钮分享信息配置
   * @param {Object} configs - 配置信息
   *   @param {Boolean} configs.isShow - 是否显示分享按钮
   *   @param {String} configs.title - 分享页面的标题，默认为当前网页的标题
   *   @param {String} configs.describe - 分享页面描述，默认为网页描述
   *   @param {String} configs.shareImg - 分享图片的地址
   *   @param {String} configs.link - 分享页面的地址
   *   @param {Boolean} configs.immediate - 显示app分享组件 客户端版本3.14.0增加此参数
   */
  appWebShare: function appWebShare(configs) {
    return this._callMethod('appWebShare', JSON.stringify(configs));
  },

  /**
  * 查看图片详情
  * 客户端 3.14.0增加此方法
  * @param {Object} config - 参数对象
  *   @param {Array} config.images - 图片url数组，不带域名的情况下客户端会默认加上photoshow的域名
  *   @param {Number} config.index - 当前需要展示的图片所在的images的index
  */
  openImagesWithIndex: function openImagesWithIndex(config) {
    var _defalut = {
      index: config.index || 0,
      images: config.images ? config.images.join(',') : ''
    };
    return this._callMethod('openImagesWithIndex', JSON.stringify(_defalut));
  },

  /**
   * 用客户端方法播放视频
   * 客户端3.19.0 通用页面增加此方法，详情页不存在版本问题
   * @param {Object} config - 参数对象
   *   @param {String} config.src - 视频地址
   *   @param {String} config.infoId - 帖子id,可选
   *   @param {String} config.adId - 广告id，可选
   *   @param {String} config.title - 视频标题，可选
   *   @param {String} config.width - 视频宽度，默认全屏
   *   @param {String} config.height - 视频高度，默认全屏
   *   @param {Number} config.second - 视频时长，默认不传，客户端会自己获取
   *   @param {String} config.posterImage - 封面图格式为 '[=id], [=url], [=order], [=size]'
   */
  playVideo: function playVideo(config) {
    return this._callMethod('playVideo', JSON.stringify(config));
  },

  /**
   * 隐藏导航栏
   * 客户端3.19.0 新增此方法
   */
  hideNavBar: function hideNavBar() {
    return this._callMethod('hideNavBar');
  },

  /**
   * 用客户端方法播放音频
   * 客户端3.19.0 通用页面增加此方法
   *   @param {String} config.url - 音频地址
   *   @param {String} config.id - 页面id,可选
   *   @param {String} config.title - 播放器显示名称
   *   @param {String} config.author - 音频作者
   *   @param {Number} config.type - 音频类型， 0|1， 0 普通音频， 1 直播
   *   @param {Function} config.cb - 播放成功的回掉函数，参数格式为 {status:'',url:'',id:'',totalTime:'',curTime:'',audioState:''}
   */
  playAudio: function playAudio(config) {
    var _defalut = {
      url: '',
      id: '',
      title: '',
      author: '',
      type: 0,
      cb: function cb() {}
    };
    var options = {};
    for (var i in _defalut) {
      options[i] = config.hasOwnProperty(i) ? config[i] : _defalut[i];
    }
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      options.cb && options.cb(data);
    };
    return this._callMethod('playAudio', JSON.stringify(options));
  },

  /**
   * 改变音频播放状态
   * 客户端3.19.0 通用页面增加此方法
   * @param {boolean} playing - 是否播放
   * @param {boolean} cb - 成功的回掉函数
   */
  changeAudioState: function changeAudioState(playing, cb) {
    var callback = cb && typeof cb === 'function' ? cb : function () {};
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      callback(data);
    };
    return this._callMethod('changeAudioState', playing);
  },

  /**
   * 获取客户端当前播放音频信息
   * 客户端3.19.0 通用页面增加此方法
   * @param {boolean} cb - 成功的回掉函数
   */
  getCurPlayingAudio: function getCurPlayingAudio(cb) {
    var callback = cb && typeof cb === 'function' ? cb : function () {};
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      callback(data);
    };
    return this._callMethod('getCurPlayingAudio');
  },

  /**
   * 隐藏客户端webView 右上方菜单
   * 存在版本兼容问题
   * @param {boolean} shouldHide - 是否隐藏
   */
  hideRightNav: function hideRightNav(shouldHide) {
    return this._callMethod('hideRightNav', shouldHide);
  }
};


/**
 * toast 提示
 * @param {Object|Number|String} options - 配置信息
 *   @param {String, Number} options.messgae - 提示信息
 *   @param {Number} options.duration - 提示显示时长
 */
function toast(options) {
    if (typeof options === 'string' || typeof options === 'number') {
      options = {
        message: options
      };
    }
    return new Toast(options);
  }

  var Toast = function () {
    function Toast(options) {
      classCallCheck(this, Toast);

      this.options = {};
      this.options.message = options.message || '';
      this.options.duration = options.duration || 2000;
      this.init();
      this.createStyle();
    }

    createClass(Toast, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this.dom = getInstance(this.options.message);
        document.body.appendChild(this.dom);
        setTimeout(function () {
          _this.dom.addEventListener('transitionend', _this.destroy.bind(_this));
          _this.dom.className += ' hide';
        }, this.options.duration);
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        document.body.removeChild(this.dom);
        this.dom.removeEventListener('trasnitioned', this.destroy);
      }
    }, {
      key: 'createStyle',
      value: function createStyle() {
        var style = document.getElementById('_sq_toast_style');
        if (style) return;
        style = document.createElement('style');
        style.id = '_sq_toast_style';
        style.innerHTML = '\n      ._sq_toast-wrapper{\n        position:fixed;\n        left: 0;\n        bottom: 15%;\n        width:100%;\n        box-sizing: border-box;\n        text-align:center;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        -webkit-transition: opacity .5s;\n        transition: opacity .5s;\n        z-index: 999;\n      }\n      ._sq_toast-wrapper.hide{\n        opacity: 0;\n      }\n      ._sq_toast--main{\n        display: inline-block;\n        background: rgba(0,0,0,.4);\n        color: #fff;\n        font-size: 14px;\n        padding: 4px 10px;\n        border-radius: 99px;\n        word-break: break-all;\n        box-sizing: border-box;\n        max-width: 60%;\n        text-align: center;\n      }\n    ';
        document.head.appendChild(style);
      }
    }]);
    return Toast;
  }();


  function getInstance(message) {
    var instance = document.createElement('div');
    instance.className = '_sq_toast-wrapper';
    var toast = document.createElement('div');
    toast.className = '_sq_toast--main';
    toast.innerText = message;
    instance.appendChild(toast);
    return instance;
  }



export default {
    isAndroid,
    isIPhone,
    isPCDebug: false,
    appInfo,
    hosts,
    app,
    toast
}




// WEBPACK FOOTER //
// ./src/common/hhkjsq.js